import { render, staticRenderFns } from "./VehicleImageInner.vue?vue&type=template&id=57c08bcd&scoped=true"
import script from "./VehicleImageInner.vue?vue&type=script&setup=true&lang=ts"
export * from "./VehicleImageInner.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c08bcd",
  null
  
)

export default component.exports